import React from 'react';
import { Box, Typography } from '@mui/material';
import { adminColors, radius } from '../../../theme/adminTheme';

// Shared "nothing here" slot for DataTable's empty state, a page with no
// results after filtering, etc. Icon + title carry the message; the
// description and action are both optional so a bare "no results, try
// clearing filters" doesn't have to force an unused action button into
// existence.
export default function EmptyState({ icon, title, description, action, sx }) {
  return (
    <Box sx={{ textAlign: 'center', py: 6, px: 3, ...sx }}>
      {icon && (
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 56,
            height: 56,
            borderRadius: radius.surface,
            backgroundColor: adminColors.accentLight,
            color: adminColors.accent,
            mb: 2,
            '& svg': { fontSize: 26 },
          }}
        >
          {icon}
        </Box>
      )}
      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: adminColors.ink, mb: description ? 0.5 : 0 }}>
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body2"
          sx={{ color: adminColors.inkSoft, maxWidth: 420, mx: 'auto', mb: action ? 2.5 : 0 }}
        >
          {description}
        </Typography>
      )}
      {action && <Box sx={{ mt: description ? 0 : 2.5 }}>{action}</Box>}
    </Box>
  );
}
